export const CONTACTTYPE_CREATE_RESET = 'CONTACTTYPE_CREATE_RESET'
export const CONTACTTYPE_CREATE_SET_CREATED = 'CONTACTTYPE_CREATE_SET_CREATED'
export const CONTACTTYPE_CREATE_SET_ERROR = 'CONTACTTYPE_CREATE_SET_ERROR'
export const CONTACTTYPE_CREATE_SET_VIOLATIONS = 'CONTACTTYPE_CREATE_SET_VIOLATIONS'
export const CONTACTTYPE_CREATE_TOGGLE_LOADING = 'CONTACTTYPE_CREATE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/contact_type/create/mutation_types.js